import React, { Component } from 'react';
import Slider from "react-slick";
import { imgSrcAddPrefix } from '../utility/global'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons"

// slickSlideNextBtn
function NextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <div
      className={className}
      style={{ ...style, right: "0px" }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronRight} />
    </div>
  );
}

// slickSlidePrevBtn
function PrevArrow(props) {
  const { className, style, onClick } = props;

  return (
    <div
      className={className}
      style={{ ...style, left: "0px" }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </div>
  );
}

export default class SlickMobileWrap extends Component {
  state = {
    slickDataInState: [],
    // 判斷是否超過 5 筆的參數
    isLessThanFive: false,
    // 頁面顯示比數 目前為 5 筆
    showAccount: 2
  }
  checkRealIndex(current) {
    const { isLessThanFive } = this.state;
    const { FacetsItemLength } = this.props;
    // 比對是不是比頁面預設比數多
    if (isLessThanFive) {
      if (current >= FacetsItemLength) {
        current = current - FacetsItemLength;
        // 目前確定組數為2個的計算index會出錯，原因是因為補的組數差所造成的，所以要再減一次
        if (current >= FacetsItemLength) {
          current = current - FacetsItemLength;
        }
      }
    }

    return current;
  }
  filterDataLengthLessThanFive() {
    const { showAccount } = this.state;
    let data = this.props.slickData;
    // 這邊確定一下要複製的資料有沒有超過 5 筆，如果沒有超過的話就在多複製 1 次，因為有看到 2 筆的狀況複製 3 次會超過 5
    data = (data.length < showAccount ?
      [...data, ...data].length < showAccount ? [...data, ...data, ...data] : [...data, ...data]
      : data)
    // console.log(data)
    this.setState({
      slickDataInState: data,
      isLessThanFive: true
    })
  }
  componentDidMount() {
    this.filterDataLengthLessThanFive();
  }
  componentDidUpdate(prevProps) {
    const {
      // FacetsIndex,
      resetSelected,
    } = this.props;
    if (this.props.isReset === true) {
      // console.log('要跑重設')
      resetSelected(false);
    }

    // if (JSON.stringify(this.props.SelectedCategoryFacets) !== JSON.stringify(prevProps.SelectedCategoryFacets)) {
    //   this.filterDataLengthLessThanFive();
    // }

  }
  render() {
    const {
      FacetsIndex,
      updateSelectedState,
      updateSamePosition,
      isReset,
      updateGoToRow,
      gotoRow,
      // excludeCategoryList,
      excludeItemList,
      // FacetsItemLength,
      slickGoToRow,
      isSendDesignCode
    } = this.props;
    const {
      slickDataInState,
      showAccount
    } = this.state;
    // slickSetting
    const settings = {
      className: "center",
      centerMode: true,
      infinite: true,
      centerPadding: "60px",
      // slidesToShow 要 -1
      slidesToShow: (showAccount - 1),
      speed: 500,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (current, next) => {
        this.setState({ oldSlide: current, activeSlide: next });
      },
      afterChange: current => {
        updateSelectedState(FacetsIndex, this.checkRealIndex(current));
        this.setState({ activeSlide: current })
        updateSamePosition( isSendDesignCode ? false : true)
        updateGoToRow(FacetsIndex)
      }
    };
    return (
      <div className="slickWrap">
        <Slider ref={slider => (this.slider = slider)} {...settings}>
          {
            !slickDataInState ? null :
              slickDataInState.map((item, index) => {
                return (
                  !(JSON.stringify(excludeItemList).indexOf(item.itype) === -1) ? null :
                    <div className="border-0 imgOuter" key={index} data-json-index={index}>
                      <img
                        className={`mx-auto`}
                        src={imgSrcAddPrefix(item.image)}
                        alt="" srcSet="" />
                    </div>
                )
              })
          }
        </Slider>
        {
          gotoRow === 0 && FacetsIndex !== 0 ?
            !this.slider ? null :
              this.slider.slickGoTo(0) : null
        }
        {/* 下面這邊是抓到 redux 裏面確定要重設了 跑一次重設的 function */}
        {
          isReset ?
            !this.slider ? null :
              this.slider.slickGoTo(0) : null
        }
        {
          isSendDesignCode && !isReset ?
            !this.slider ? null :
              this.slider.slickGoTo(slickGoToRow.showIndex)
            :
            null
        }
      </div>
    );
  }
}
